exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:800&display=swap&text=NCBLibray);", ""]);
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Noto+Sans+JP:300,500,900);", ""]);
exports.push([module.id, "@import url(https://use.fontawesome.com/releases/v5.8.1/css/all.css);", ""]);

// module
exports.push([module.id, "@media all and (min-width: 1200px), print {\n.sp {\n    display: none;\n}\n}\n.initial {\n  color: white !important;\n  cursor: pointer;\n  margin-right: 5px;\n  padding: 0px 10px;\n  background: rgba(32, 32, 32, 0.4);\n  margin-bottom: 5px;\n  font-family: \"Nunito\", sans-serif;\n  text-align: center;\n  display: inline-block;\n}\n.initial.active {\n  background: #0042bd;\n}\n.initial-wrap {\n  margin: 10px 0px;\n}", ""]);

// exports
